<template>
    <div v-if="inputVal">
        <student-worksheet-module-wrapper
            :module="module"
            :module-complete="response.module_complete"
            :worksheet-complete="worksheetComplete"
        >
            <div class="px-8">
                <div class="grid select-none grid-cols-2 gap-4">
                    <div
                        :class="
                            'relative rounded bg-gray-100 p-4' +
                            ' ' +
                            (response.module_complete ? 'bg-green-50' : '')
                        "
                    >
                        <div
                            v-if="!orderedItems.length"
                            class="flex w-full items-center justify-center text-center text-gray-725"
                        >
                            <div>Drag and drop items in the correct order</div>
                        </div>
                        <draggable
                            class="mb-4"
                            v-model="orderedItems"
                            :disabled="response.module_complete"
                            :group="'items' + ' ' + module.id"
                            ghost-class="ghost"
                            :empty-insert-threshold="100"
                            @change="onMove"
                        >
                            <div
                                v-for="(item, iIndex) in orderedItems"
                                :key="item.title"
                                :class="
                                    'mb-2 cursor-pointer rounded border bg-white p-3 text-[16px] font-semibold text-gray-625 shadow' +
                                    ' ' +
                                    (item.is_in_correct_order
                                        ? '!bg-green-400 text-white'
                                        : '!bg-red-400 text-white')
                                "
                            >
                                {{ item.title }}
                            </div>
                        </draggable>
                    </div>

                    <div
                        :class="
                            'p-4' +
                            ' ' +
                            (response.module_complete ? 'opacity-50' : '')
                        "
                    >
                        <draggable
                            class="flex select-none flex-col"
                            v-model="remainingOptions"
                            :disabled="response.module_complete"
                            :group="'items' + ' ' + module.id"
                            ghost-class="ghost"
                            @change="onMove"
                            :empty-insert-threshold="100"
                            :swap-threshold="100"
                        >
                            <div
                                v-for="(option, iIndex) in remainingOptions"
                                :key="option.title"
                            >
                                <div
                                    class="mb-2 cursor-pointer rounded border bg-white p-3 text-[16px] font-semibold text-gray-625 shadow"
                                >
                                    {{ option.title }}
                                </div>
                            </div>
                        </draggable>
                    </div>
                </div>
            </div>
        </student-worksheet-module-wrapper>
    </div>
</template>

<script>
import StudentWorksheetModuleWrapper from "@/Components/StudentWorksheetModuleWrapper";
import { VueDraggableNext } from "vue-draggable-next";

export default {
    name: "StudentWorksheetModuleOrder",
    components: {
        StudentWorksheetModuleWrapper,
        draggable: VueDraggableNext,
    },
    props: ["modelValue", "module", "worksheetComplete"],
    data() {
        return {
            response: {},
            orderedItems: [],
            remainingOptions: [],
        };
    },

    methods: {
        onMove: function () {
            this.response = {
                ordered_items: this.orderedItems,
                remaining_options: this.remainingOptions,
                module_complete: this.checkPositions(),
            };

            this.inputVal = this.response;
        },
        checkPositions: function () {
            let nextPosition = 0;
            let allCorrect = true;

            this.orderedItems.forEach(function (item, index) {
                item.is_in_correct_order =
                    !item.is_distractor && item.correct_order === index;

                if (item.is_distractor || !item.is_in_correct_order) {
                    allCorrect = false;
                }
            });

            this.remainingOptions.forEach(function (item) {
                if (!item.is_distractor) {
                    allCorrect = false;
                }
            });

            return allCorrect;
        },
    },
    mounted() {
        let vm = this;

        if (!vm.modelValue) {
            vm.module.content.options.forEach(function (option, index) {
                vm.remainingOptions.push({
                    title: option,
                    correct_order: index,
                    is_in_correct_order: false,
                    is_distractor: false,
                });
            });

            vm.module.content.distractors.forEach(function (distractor) {
                vm.remainingOptions.push({
                    title: distractor,
                    correct_order: false,
                    is_in_correct_order: false,
                    is_distractor: true,
                });
            });

            this.response = {
                ordered_items: [],
                remaining_options: vm.remainingOptions,
                module_complete: false,
            };
        } else {
            this.response = {
                ordered_items: this.modelValue.ordered_items,
                remaining_options: this.modelValue.remaining_options,
                module_complete: this.modelValue.module_complete,
            };

            vm.orderedItems = this.modelValue.ordered_items;
            vm.remainingOptions = this.modelValue.remaining_options;
        }

        this.inputVal = this.response;

        vm.remainingOptions = _.shuffle(vm.remainingOptions);
    },
    computed: {
        inputVal: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit("update:modelValue", val);
            },
        },
    },
};
</script>

<style scoped lang="postcss">
.item {
    @apply m-2 mb-2 cursor-pointer rounded border border-neutral-30 bg-neutral-20 p-2 text-[14px] font-semibold;
}

.correct {
    @apply border-success-default bg-success-default text-white;
}

.incorrect {
    @apply border-danger-default bg-danger-default text-white;
}

.ghost {
    opacity: 0.3;
    background: transparent;
    color: transparent;
    border: 1px dashed #0e6196;
}

.sortable-chosen {
    @apply bg-primary-default text-white;
}
</style>
